<template>
    <div class="vendors-details">
      <div class="d-none d-md-block">
        <h2 class="font-weight-bold mb-4">Vendors</h2>
        <div class="d-flex align-items-center mb-4">
            <router-link :to="'/vendors'" exact> 
                <p class="mb-0 xfont-weight-bold">Vendors</p>
            </router-link>
            <i class="fas fa-chevron-right mx-3"></i>
            <router-link :to="{ name: 'Make Payment' }" exact> 
              <p class="mb-0">Make Payment</p>
            </router-link>
            <i v-if="getRoute == 'Payment Methods' || getRoute == 'Pay with Wallet' || getRoute == 'Make Payment Summary'" class="fas fa-chevron-right mx-3"></i>
            <router-link v-if="getRoute == 'Payment Methods' || getRoute == 'Pay with Wallet' || getRoute == 'Make Payment Summary'" :to="{ name: 'Payment Methods' }" exact> 
              <p class="mb-0">Payment Methods</p>
            </router-link>
            <i v-if="getRoute == 'Pay with Wallet'" class="fas fa-chevron-right mx-3"></i>
            <router-link v-if="getRoute == 'Pay with Wallet'" :to="{ name: 'Pay with Wallet' }" exact> 
              <p class="mb-0">Pay with Wallet</p>
            </router-link>
            <i v-if="getRoute == 'Make Payment Summary'" class="fas fa-chevron-right mx-3"></i>
            <router-link v-if="getRoute == 'Make Payment Summary'" :to="{ name: 'Make Payment Summary' }" exact> 
              <p class="mb-0">Make Payment Summary</p>
            </router-link>
        </div>
      </div>
      <MobileBreadCrumb :title="customer_account.name" />
      <router-view></router-view>
      <FooterMobile />
    </div>
</template>
<script>
import TransactionAPI from '../api/transactions_api';
import store from '../store';
import MobileBreadCrumb from '../components/MobileBreadCrumb.vue';
import FooterMobile from '../components/FooterMobile.vue';

  export default {
    components: {
      MobileBreadCrumb,
      FooterMobile
    },
    data() {
      return {
        dismissCountDown: 0,
        errorMessage: '',
        proceedLoading: false,
        selected_service_types: null,
        selected_currency: null,
        options: [],
        options2: [],
        validation: {},
        errors: []
      }
    },
    beforeMount() {
      //this.init();
    },
    mounted () {
    },
    computed: {
      getRoute() {
        let pathName = this.$route.name;

        return pathName;
      },
      customer_account: {
        get: function () {
          return store.state.customer_account;
        },
        set: function (newValue) {
          store.state.customer_account = newValue;
        }
      },
      payerVendors: {
        get: function () {
          return store.state.payerVendors;
        },
        set: function (newValue) {
          store.state.payerVendors = newValue;
        }
      },
      serviceTypes: {
        get: function () {
          return store.state.serviceTypes;
        },
        set: function (newValue) {
          store.state.serviceTypes = newValue;
        }
      },
      currencies: {
        get: function () {
          return store.state.currencies;
        },
        set: function (newValue) {
          store.state.currencies = newValue;
        }
      },
      checkout_details: {
        get: function () {
          return store.state.checkout_details;
        },
        set: function (newValue) {
          store.state.checkout_details = newValue;
        }
      },
    },
    methods: {}
  }
</script>
<style scoped>
.bg-gray {
  background: #f1f1f1;
}
.rounded-pills {
    border-radius: 30px;
}
.font-20 {
    font-size: 20px;
}
a.router-link-active,
li.router-link-active a {
  color: #000;
  font-weight: bold;
}
@media (max-width: 767px) {
  .button-width {
    width: 100%;
  }
}
@media (min-width: 768px) {
  .bg-md-gray {
    background: #f1f1f1;
  }
  .bg-md-white {
    background: white;
  }
}
</style>